import OdometerInformation from 'src/components/ConnectedVehicle/OdometerInformation/OdometerInformation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(OdometerInformation);